import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { SessionStorageService } from '../services/session-storage.service';
import { ShopService } from '../services/shop.service';
import HwUtil from '../utils/hw-util';
import { UrlParam } from '../models/url-param';
import { DialogService } from '../services/dialog.service';

@Injectable()
export class HwAuthInterceptor implements HttpInterceptor {
    protected shopService = inject(ShopService);
    protected router = inject(Router);
    protected sessionStorageService = inject(SessionStorageService);
    protected dialogService = inject(DialogService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.url.startsWith('/assets')) {
            return next.handle(req);
        }

        if (req.url.endsWith('/api/subscriber/login')) {
            return next.handle(req);
        }

        if (this.shopService.isAuthTokenExpired()) {
            this.sessionStorageService.clearBasket();
            this.sessionStorageService.clearToken();
            this.sessionStorageService.clearUserData();

            return next.handle(req).pipe(
                tap(
                    () => {
                        let urlParams = this.sessionStorageService.getUrlParams();
                        if (urlParams)
                            this.sessionStorageService.clearUrlParams();

                        let returnUrl = this.sessionStorageService.getReturnUrl();
                        if (returnUrl) {
                            this.sessionStorageService.clearReturnUrl();
                            HwUtil.redirectWithoutHistory(returnUrl)
                        }
                    }));

        } else {
            const token = this.sessionStorageService.getAuthToken().AccessToken;
            const urlParams: UrlParam = this.sessionStorageService.getUrlParams()

            const cloned = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                    "Accept-Language": urlParams?.Language4Digit ?? "hu-HU",
                }
            });
            return next.handle(cloned);
        }
    }
}
